<template>
  <app-layout>
    <div class="py-12">
      <div
        class="
          bg-gray-50
          max-w-screen-sm
          mx-auto
          shadow
          border-vice-dark-grey
          overflow-hidden
          sm:rounded-lg
          mt-10
        "
      >
        <div class="px-4 py-5 sm:px-6 border rounded-t-lg">
          <h3 class="text-lg leading-6 font-medium text-vice-teal-700">Invitation to session</h3>
        </div>
        <!-- Main 3 column grid -->
        <div class="bg-white border border-t-0 text-center rounded-b-lg">
          <div class="px-4 py-5 sm:p-6">
            <div class="mt-2 max-w-xl m-auto text-sm text-gray-500">
              <p class="mb-4">
                You have been invited to
                <br />
                <b class="text-lg">"{{ $page.props.sessionInvite.session.title }}"</b>
                <br />
                by {{ $page.props.sessionInvite.session.details.clinician?.name }}.
              </p>
              <p>
                The session starts on
                {{ formatedSessionStartDate }}
              </p>
            </div>
            <div class="mt-5">
              <inertia-link
                data-cy="accept-invitation"
                :href="
                  route('session.accept_invitation', [
                    this.$page.props.sessionInvite.token,
                    this.$page.props.sessionInvite.email,
                  ])
                "
                method="post"
                as="button"
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  text-xs
                  uppercase
                  font-medium
                  rounded-md
                  text-white
                  bg-vice-teal-700
                  hover:bg-vice-teal-200
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
                "
              >
                Accept Invitation
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import dayjs from 'dayjs';
import { AcademicCapIcon } from '@heroicons/vue/outline';
import AppLayout from '@/Layouts/AppLayout.vue';

const tabs = [
  { name: 'GP Chat', href: '#', current: true },
  { name: 'Resources', href: '#', current: false },
];

const user = {
  name: 'Dr. Chelsea Hagon',
  email: 'chelseahagon@example.com',
  role: 'General Practitioner',
  imageUrl:
    'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
};
const navigation = [
  { name: 'Home', href: '#', current: true },
  { name: 'Profile', href: '#', current: false },
  { name: 'Resources', href: '#', current: false },
  { name: 'Company Directory', href: '#', current: false },
  { name: 'Openings', href: '#', current: false },
];
const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: '#' },
  { name: 'Sign out', href: '#' },
];
const stats = [
  { label: '', value: '' },
  { label: '', value: '' },
  { label: 'Personal days left', value: 2 },
];
const actions = [
  {
    icon: AcademicCapIcon,
    name: 'Quizz',
    href: '#',
    iconForeground: 'text-teal-700',
    iconBackground: 'bg-teal-50',
  },
];

export default {
  components: {
    AppLayout,
  },
  methods: {
    showTab(tab) {
      this.tabs[0].current = false;
      this.tabs[1].current = false;
      tab.current = true;
    },
  },
  computed: {
    formatedSessionStartDate() {
      return dayjs(this.$page.props.sessionInvite.session.details.session_start_by_timezone).format(
        'dddd, MMMM D [at] h:mm A',
      );
    },
  },
  setup() {
    return {
      user,
      navigation,
      userNavigation,
      stats,
      actions,
      tabs,
    };
  },
};
</script>
